var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrossWeightIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19995 3.20001L0.699951 12.2M5.19995 3.20001L9.69995 12.2M5.19995 3.20001H11.7M0.699951 12.2C0.699951 18.7 9.69995 18.7 9.69995 12.2M0.699951 12.2H9.69995M23.2 3.20001L18.7 12.2M23.2 3.20001L27.7 12.2M23.2 3.20001H16.7M18.7 12.2C18.7 18.7 27.7 18.7 27.7 12.2M18.7 12.2H27.7M16.7 3.20001C16.7 4.58072 15.5807 5.70001 14.2 5.70001M16.7 3.20001C16.7 1.8193 15.5807 0.700012 14.2 0.700012C12.8193 0.700012 11.7 1.8193 11.7 3.20001M14.2 5.70001C12.8193 5.70001 11.7 4.58072 11.7 3.20001M14.2 5.70001V18.325M10.2 21.7H7.69999V24.7H20.7V21.7H18.2M10.2 21.7C10.2 19.45 12.2 18.325 14.2 18.325M10.2 21.7H18.2M18.2 21.7C18.2 19.45 16.2 18.325 14.2 18.325",
    stroke: "#11334E",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossWeightIcon1);
export default __webpack_public_path__ + "static/media/grossWeightIcon1.1b6ab089541f42c7db4177060798f88d.svg";
export { ForwardRef as ReactComponent };